import { ApolloClient, InMemoryCache } from "@apollo/client";

export const client = new ApolloClient({
  cache: new InMemoryCache(),

  uri: "https://evrbed.myshopify.com/api/2022-04/graphql.json",
  headers: {
    "X-Shopify-Access-Token": `${process.env.SHOPIFY_STORE_FRONT_APP_PASSWORD}`,
  },
});

export default client;
